<ion-grid class="checkout-settings-page">
  <!-- ─────────── Fizetési szolgáltató választása ─────────── -->
  <ion-row>
    <ion-col size="12">
      <ion-card>
        <ion-card-header>
          <ion-card-title>Fizetési mód</ion-card-title>
          <ion-card-subtitle>
            Ezzel dől el, milyen fizetési gombot kapnak a szülők a számláknál és az egyenlegnél.
          </ion-card-subtitle>
        </ion-card-header>
        <ion-card-content *ngIf="!simpleLoading">
          <ion-segment [(ngModel)]="simple.szolgaltato" scrollable="true">
            <ion-segment-button value="stripe"><ion-label>Stripe (bankkártya)</ion-label></ion-segment-button>
            <ion-segment-button value="simple"><ion-label>OTP SimplePay</ion-label></ion-segment-button>
            <ion-segment-button value="mindketto"><ion-label>Mindkettő</ion-label></ion-segment-button>
            <!-- Teljes kikapcsolás: nem „nincs beállítva", hanem tudatos döntés. -->
            <ion-segment-button value="nincs"><ion-label>Egyik sem</ion-label></ion-segment-button>
          </ion-segment>

          <ion-note color="warning" *ngIf="simpleKeszEllenorzes() as hiany">
            <ion-icon name="warning-outline"></ion-icon>
            {{ hiany }} Amíg ez hiányzik, a rendszer biztonsági okból a Stripe fizetést kínálja.
          </ion-note>
          <ion-note color="medium" *ngIf="!simpleKeszEllenorzes()">
            <span *ngIf="simple.szolgaltato === 'stripe'">A szülők a meglévő Stripe fizetőoldalt kapják.</span>
            <span *ngIf="simple.szolgaltato === 'simple'">A szülők az OTP SimplePay fizetőoldalt kapják.</span>
            <span *ngIf="simple.szolgaltato === 'mindketto'">A szülők mindkét fizetési módot látják, és választhatnak.</span>
            <span *ngIf="simple.szolgaltato === 'nincs'">
              <b>A bankkártyás fizetés ki van kapcsolva.</b> A szülők nem látnak fizetés gombot;
              a helyén az áll, hogy „Jelenleg nem aktív egy fizetőkapu sem". A fizetőoldal
              közvetlen linkkel sem nyílik meg — a kiszolgáló is elutasítja.
            </span>
          </ion-note>

          <div class="actions">
            <ion-button color="primary" [disabled]="simpleSaving" (click)="saveSimple()">
              <ion-icon slot="start" name="save"></ion-icon>
              {{ simpleSaving ? 'Mentés...' : 'Fizetési mód mentése' }}
            </ion-button>
          </div>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <!-- ─────────── OTP SimplePay kereskedői adatok ─────────── -->
  <ion-row>
    <ion-col size="12">
      <ion-card>
        <ion-card-header>
          <ion-card-title>OTP SimplePay beállítása</ion-card-title>
          <ion-card-subtitle>
            A kereskedői azonosító és a titkos kulcs a SimplePay admin felületén, a
            „Technikai adatok” oldalon található (MERCHANT és SECRET_KEY).
          </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content *ngIf="!simpleLoading; else simpleLoadingState">
          <ion-item lines="full" class="mode-toggle">
            <ion-label>
              <h2>SimplePay bekapcsolva</h2>
              <p>Kikapcsolva a SimplePay fizetés nem indítható, függetlenül a fenti választótól.</p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="simple.aktiv"></ion-toggle>
          </ion-item>

          <!-- PRÓBAÜZEM: úgy lehet kipróbálni egy kaput, hogy közben a szülők ne lássák. -->
          <ion-item lines="full" class="mode-toggle" *ngIf="simple.szolgaltato !== 'nincs'">
            <ion-label>
              <h2>Próbaüzem — csak adminisztrátoroknak</h2>
              <p>
                Bekapcsolva a fizetés <b>csak neked</b> (és a többi adminisztrátornak) jelenik meg;
                a szülők ugyanazt látják, mint kikapcsolt állapotban. Így élesítés előtt végig lehet
                menni a folyamaton anélkül, hogy bárki más belefutna. A fizetőoldal ilyenkor csak a
                felületről indítva nyílik meg (rövid életű, adminhoz kötött kulccsal), közvetlen
                linkkel nem. <b>Kapcsold ki, amikor élesíted.</b>
              </p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="simple.probauzem"></ion-toggle>
          </ion-item>

          <ion-item lines="full" class="mode-toggle">
            <ion-label>
              <h2>SANDBOX (teszt) mód</h2>
              <p>
                Bekapcsolva a sandbox.simplepay.hu felé megy a fizetés, valódi terhelés nélkül.
                Kikapcsolva az éles secure.simplepay.hu rendszert használja.
              </p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="simple.test_mode"></ion-toggle>
          </ion-item>

          <ion-grid>
            <ion-row>
              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Teszt (sandbox) fiók</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a SANDBOX mód aktív.</p>
                  <ion-input label="Teszt MERCHANT azonosító" label-placement="stacked" fill="outline"
                             [(ngModel)]="simple.test_merchant"></ion-input>
                  <ion-input label="Teszt SECRET_KEY" label-placement="stacked" fill="outline" type="password"
                             placeholder="üresen hagyva marad a korábbi" [(ngModel)]="simple.test_secret_key"></ion-input>
                  <div class="secret-status">
                    <ion-badge [color]="simple.test_secret_key_beallitva || simple.test_secret_key ? 'success' : 'medium'">Secret key</ion-badge>
                  </div>
                </section>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Éles fiók</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a SANDBOX mód ki van kapcsolva.</p>
                  <ion-input label="Éles MERCHANT azonosító" label-placement="stacked" fill="outline"
                             [(ngModel)]="simple.live_merchant"></ion-input>
                  <ion-input label="Éles SECRET_KEY" label-placement="stacked" fill="outline" type="password"
                             placeholder="üresen hagyva marad a korábbi" [(ngModel)]="simple.live_secret_key"></ion-input>
                  <div class="secret-status">
                    <ion-badge [color]="simple.live_secret_key_beallitva || simple.live_secret_key ? 'success' : 'medium'">Secret key</ion-badge>
                  </div>
                </section>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Adattovábbítási nyilatkozat adatai</h3>
                  <p class="section-help">
                    A SimplePay előírja, hogy a fizetés előtt a vásárló elfogadja az adattovábbítási
                    nyilatkozatot. Ezek az adatok jelennek meg benne.
                  </p>
                  <ion-input label="Kereskedő cégneve" label-placement="stacked" fill="outline" [(ngModel)]="simple.ceg_nev"></ion-input>
                  <ion-input label="Székhelye" label-placement="stacked" fill="outline" [(ngModel)]="simple.ceg_szekhely"></ion-input>
                  <ion-input label="Fizetési elfogadóhely webcíme" label-placement="stacked" fill="outline" [(ngModel)]="simple.webcim"></ion-input>
                </section>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Technikai</h3>
                  <ion-input label="Pénznem" label-placement="stacked" fill="outline" [(ngModel)]="simple.penznem"></ion-input>
                  <ion-input label="Publikus alapcím (opcionális)" label-placement="stacked" fill="outline"
                             placeholder="pl. https://sulinform.hu" [(ngModel)]="simple.base_url"></ion-input>
                  <p class="section-help">
                    Csak a domaint add meg, útvonal nélkül – a végpontokat a rendszer fűzi hozzá.
                    Üresen hagyva a hívás szerinti címet használja.
                  </p>
                  <ion-item lines="none" *ngIf="simple.ipn_url">
                    <ion-label class="ion-text-wrap">
                      <h3>IPN URL</h3>
                      <p>Ezt kell beállítani a SimplePay admin „Technikai adatok” oldalán:</p>
                      <p><code>{{ simple.ipn_url }}</code></p>
                    </ion-label>
                  </ion-item>
                  <ion-item lines="none" *ngIf="simple.back_url">
                    <ion-label class="ion-text-wrap">
                      <h3>Visszairányítási cím</h3>
                      <p>Ide tér vissza a vásárló a fizetés után – a rendszer küldi a SimplePay-nek:</p>
                      <p><code>{{ simple.back_url }}</code></p>
                    </ion-label>
                  </ion-item>
                  <ion-item lines="none" *ngIf="simple.teszt_url">
                    <ion-label class="ion-text-wrap">
                      <h3>Teszt-URL (próbafizetés belépés nélkül)</h3>
                      <p>Megnyitva számla és belépés nélkül végig lehet menni a fizetésen – ezt lehet a
                        SimplePay-nek is megadni az élesítéshez. A próbafizetés nem könyvelődik; a cím a
                        mentett kulcsból készül, ezért kulcscsere után megváltozik.</p>
                      <p><a [href]="simple.teszt_url" target="_blank" rel="noopener"><code>{{ simple.teszt_url }}</code></a></p>
                    </ion-label>
                  </ion-item>
                </section>
              </ion-col>

              <ion-col size="12">
                <ion-note color="medium">
                  A SECRET_KEY mezőt üresen hagyva mentéskor megmarad a korábban elmentett kulcs –
                  nem kell újra bemásolni. A mentett kulcsot a rendszer soha nem küldi vissza a felületre.
                </ion-note>
              </ion-col>

              <ion-col size="12" class="actions">
                <ion-button color="primary" [disabled]="simpleSaving" (click)="saveSimple()">
                  <ion-icon slot="start" name="save"></ion-icon>
                  {{ simpleSaving ? 'Mentés...' : 'SimplePay beállítások mentése' }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>

  <ion-row>
    <ion-col size="12">
      <ion-card>
        <ion-card-header>
          <ion-card-title>Checkout fizetés beállítása</ion-card-title>
          <ion-card-subtitle>
            A régi Stripe checkout fizetési rendszer teszt/éles módja és kulcsai.
          </ion-card-subtitle>
        </ion-card-header>

        <ion-card-content *ngIf="!loading; else loadingState">
          <ion-item lines="full" class="mode-toggle">
            <ion-label>
              <h2>Checkout teszt mód</h2>
              <p>
                Bekapcsolva a checkout nem vár valódi Stripe callbackre, hanem a teszt fizetés elfogadása gombbal szimulálja a sikeres fizetést.
              </p>
            </ion-label>
            <ion-toggle slot="end" [(ngModel)]="settings.test_mode"></ion-toggle>
          </ion-item>

          <ion-grid>
            <ion-row>
              <ion-col size="12">
                <ion-note color="medium">
                  Az alapértelmezett díjbekérő/számla tömb beállítása átkerült a <b>Pénzügy → Számlatömbök</b> menüpontba.
                </ion-note>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Teszt Stripe adatok</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a checkout teszt mód aktív.</p>

                  <ion-input label="Teszt publishable key" label-placement="stacked" fill="outline" [(ngModel)]="settings.test_publishable_key"></ion-input>
                  <ion-input label="Teszt secret key" label-placement="stacked" fill="outline" type="password" [(ngModel)]="settings.test_secret_key"></ion-input>
                  <ion-input label="Teszt webhook secret" label-placement="stacked" fill="outline" type="password" [(ngModel)]="settings.test_webhook_secret"></ion-input>

                  <div class="secret-status">
                    <ion-badge [color]="settings.has_test_secret_key || settings.test_secret_key ? 'success' : 'medium'">Secret key</ion-badge>
                    <ion-badge [color]="settings.has_test_webhook_secret || settings.test_webhook_secret ? 'success' : 'medium'">Webhook secret</ion-badge>
                  </div>
                </section>
              </ion-col>

              <ion-col size="12" sizeLg="6">
                <section class="settings-section">
                  <h3>Éles Stripe adatok</h3>
                  <p class="section-help">Ezt használja a rendszer, ha a checkout teszt mód ki van kapcsolva.</p>

                  <ion-input label="Éles publishable key" label-placement="stacked" fill="outline" [(ngModel)]="settings.live_publishable_key"></ion-input>
                  <ion-input label="Éles secret key" label-placement="stacked" fill="outline" type="password" [(ngModel)]="settings.live_secret_key"></ion-input>
                  <ion-input label="Éles webhook secret" label-placement="stacked" fill="outline" type="password" [(ngModel)]="settings.live_webhook_secret"></ion-input>

                  <div class="secret-status">
                    <ion-badge [color]="settings.has_live_secret_key || settings.live_secret_key ? 'success' : 'medium'">Secret key</ion-badge>
                    <ion-badge [color]="settings.has_live_webhook_secret || settings.live_webhook_secret ? 'success' : 'medium'">Webhook secret</ion-badge>
                  </div>
                </section>
              </ion-col>

              <ion-col size="12">
                <ion-note color="medium">
                  Ha egy kulcs mezőt üresen hagysz mentéskor, a backend megtartja az adatbázisban lévő korábbi értéket. Így nem kell minden módosításnál újra bemásolni a secret kulcsokat.
                </ion-note>
              </ion-col>

              <ion-col size="12" class="actions">
                <ion-button color="primary" [disabled]="saving" (click)="saveSettings()">
                  <ion-icon slot="start" name="save"></ion-icon>
                  {{ saving ? 'Mentés...' : 'Mentés' }}
                </ion-button>
              </ion-col>
            </ion-row>
          </ion-grid>
        </ion-card-content>
      </ion-card>
    </ion-col>
  </ion-row>
</ion-grid>

<ng-template #loadingState>
  <ion-card-content>
    <ion-spinner name="crescent"></ion-spinner>
    <span class="loading-text">Checkout beállítások betöltése...</span>
  </ion-card-content>
</ng-template>

<ng-template #simpleLoadingState>
  <ion-card-content>
    <ion-spinner name="crescent"></ion-spinner>
    <span class="loading-text">SimplePay beállítások betöltése...</span>
  </ion-card-content>
</ng-template>
